import { all } from "redux-saga/effects";
import { attendanceConfigWatcher } from "./Attendance/attendanceConfigSagas";
import { authWatcher } from "./auth/authSagas";
import { checklistConfigWatcher } from "./ChecklistPlanner/checklistConfigSagas";
import { dashboardConfigWatcher } from "./DashboardConfig/dashboardConfigSagas";
import { employeeHelpdeskConfigWatcher } from "./Employee Helpdesk/employeeHelpDeskConfigSagas";
import { leaveConfigWatcher } from "./LeaveConfig/leaveConfigSagas";
import { myCertificateConfigWatcher } from "./MyCertificate/myCertificateConfigSagas";
import { spotRewardsConfigWatcher } from "./MyCertificate/SpotRewards/spotRewardsConfigSagas";
import { spotRewardConfigWatcher } from "./SpotRewardConfig/spotRewardConfigSaga";

export function* watchSagas() {
  yield all([
    authWatcher(),
    dashboardConfigWatcher(),
    leaveConfigWatcher(),
    spotRewardConfigWatcher(),
    attendanceConfigWatcher(),
    myCertificateConfigWatcher(),
    employeeHelpdeskConfigWatcher(),
    spotRewardsConfigWatcher(),
    checklistConfigWatcher(),
  ])
}